import { APIGet, APIPost, APIPut, StatusCode, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TProductVendor, TVendorContact } from "redux/reducers/models/product";

export type TGetVendors = {
  id?: string | number;
  /**
   * - search by title
   * - minimum length: > 2
   */
  search?: string;
};

interface IVendorBody {
  title: string;
  address_line?: string;
  address_line_2?: string;
  city?: string;
  province?: string;
  country?: string;
  postal_code?: string;
  notes?: string;
  email?: string;
  phone?: string;
  contact_name?: string;
  contacts?: TVendorContact[];
}

type IPostVendor = IVendorBody;

interface IPutVendor extends IVendorBody {
  id: number;
}

interface IPostVendorRes {
  data: TProductVendor;
  message: string;
  status: StatusCode;
}

export async function GetVendor(params: TGetVendors, useGlobalLoader?: boolean, token?: CancelToken) {
  return await APIGet<TProductVendor[]>(
    APIUrl(AdminType.FacilityAdmin, "/product/vendor"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PostVendor(params: IPostVendor, useGlobalLoader?: boolean): Promise<IPostVendorRes> {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/product/vendor"), params, useGlobalLoader);
}

export async function PutVendor(params: IPutVendor, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/product/vendor"), params, useGlobalLoader);
}
